import { Popup } from '@gem/popups';

import { NewUsersPopupView } from 'APP/main/Popups/GetParametersManager/Popups/NewUsersPopup/NewUsersPopupView/NewUsersPopupView';
import { useClearGetParameters } from 'APP/router/hooks/useClearGetParameters';

export const NewUsersPopup = () => {
  const clearGetParameters = useClearGetParameters();

  return (
    <Popup
      isOpened
      onClose={clearGetParameters}
    >
      <NewUsersPopupView />
    </Popup>
  );
};
